/* @flow */
import { flatten } from 'lodash';
import { callLiferayEndpoint } from './index';
import utils from './utils';

import type { CartItem, WorklistItem } from 'types';

const findItems = async (): Promise<CartItem[]> => {
  const endpoint = '/protones-portlet.cartitems/find-cart-item-for-worklist-item-by-user';
  // TODO: Fix `start` & `end`
  const response = await callLiferayEndpoint(endpoint, {
    start: 0,
    end: 99999,
  });
  return response.map(utils.toCartItem);
};

const createItems = async (worklistItems: WorklistItem[]): Promise<CartItem[]> => {
  const endpoint = '/protones-portlet.cartitems/add-worklist-item-licensing-cart-item';
  const responses = await Promise.all(
    worklistItems.map(worklistItem => {
      const components = flatten(
        (worklistItem.mergedComponents || []).map(c => c.components || [])
      );
      const componentIds = components.map(c => c.right.id);
      const params = {
        worklistItemId: worklistItem.id,
        selectedTipiDirittoIds: componentIds,
      };
      return callLiferayEndpoint(endpoint, params);
    })
  );
  return responses.map(utils.toCartItem);
};

const deleteItems = async (cartItems: CartItem[]): Promise<number[]> => {
  const response = await Promise.all(
    cartItems.map(item =>
      callLiferayEndpoint('/protones-portlet.cartitems/delete', {
        cartItemId: item.id,
      })
    )
  );
  return response.map(item => item.cartItemId);
};

const buyLicensingCartItems = async (cartItems: CartItem[]): Promise<CartItem[]> => {
  const buyPromises = cartItems.map(cartItem => {
    const components = flatten(
      (cartItem.worklistItem.mergedComponents || []).map(c => c.components || [])
    );
    const componentIds = components.map(c => c.right.id);
    return callLiferayEndpoint('/protones-portlet.cartitems/buy-licensing-cart-item', {
      cartItemId: cartItem.id,
      tipoDirittoIds: componentIds,
    });
  });
  await Promise.all(buyPromises);
  return cartItems;
};

export default {
  items: {
    find: findItems,
    create: createItems,
    delete: deleteItems,
    buy: buyLicensingCartItems,
  },
};
